import { Link } from 'react-router-dom'
import { pages } from '../../../config/routes';
import Logo from '../../logo';
import './styles.scss'

function DesktopNavigation() {
  const CLASS_NAME = "desktop-navigation"
  return (
    <nav className={CLASS_NAME}>
      <div className={`${CLASS_NAME}-container flex-center`}>
        <Logo/>
        <div className={`${CLASS_NAME}-links`}>
          <Link to={pages.home}>Home</Link>
          <Link to={pages.capabilities}>Capabilities</Link>
          <Link to={pages.contact}>Contact</Link>
          <Link to={pages.whyKeyes2Safety}>Why Keyes2Safety?</Link>
        </div>
      </div>
    </nav>
  );
}

export default DesktopNavigation;